import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import TaxRoundingConfigFields from "./TaxRoundingConfigFields";
import React, { useEffect, useState } from "react";

const UpdateTaxRoundingConfig = () => {



    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Tax Rounding Configs", url: "/tax-rounding-config" },
        { content: "Update Tax Rounding Config", url: "" }
    ]
    )



    return (
        <>
            <TaxRoundingConfigFields crumbs={crumbs} title={"Update Tax Rounding Config"} btnText={"Update"} 
            isReadOnly={hasPermission(["TAXRCONF-U"]) === false}/>

        </>
    )
}

export default UpdateTaxRoundingConfig;